/**
 * Hệ thống tài khoản
 * NVTUAN1 22.07.2022
 */
export default {
  BudgetActiveMoney: '3371', //Kinh phí hoạt động bằng tiền
  BudgetActiveGovernmentMoney: '511', //Thu hoạt động do NSNN cấp
  EstimateRegularExpenxe: '00821', // Dự toán chi thường xuyên
  EstimateIrregularExpenxe: '00822', // Dự toán chi không thường xuyên
  BalanceSheetAccountsDefault: ['0061','0062','00811','00812','00813','00821','00822', '00823','0091','0092','0093'], // danh sách tài khoản ngoại bản là tài khoản con của 006,008,009
  RegularFund :'008211', // kinh phí thường xuyên
  IrregularFund: '008221', // Kinh phí không thường xuyên
  BasicConstructFund: '00921', //kinh phí xây dựng cơ bản
};
